var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-container mt-3 flex"},[_c('div',{staticClass:"btn-group",class:{
    'btn-active': !_vm.isGrouped,
  },on:{"click":function($event){return _vm.$emit('onUnGroup')}}},[_vm._v("Ungrouped")]),_c('div',{staticClass:"btn-group",class:{
    'btn-active': _vm.isGrouped,
  },on:{"click":function($event){return _vm.$emit('onGroup')}}},[_vm._v("Grouped")])])
}
var staticRenderFns = []

export { render, staticRenderFns }